import Information from './row-svg/information.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function InformationIcon(props: FixMe) {
  return <img {...props} alt="information icon" src={Information} />;
}

export default InformationIcon;
